<div class="text-start card-docs">
  <button
    class="folder-records__item"
    type="button"
    aria-label="Download medical record summary PDF"
    (click)="generatePdfDocument()"
  >
    <span class="folder-records__item__icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="4.5"
          d="m18 31.5 14 12m0 0 14-12m-14 12V14M16 52h32"
        />
      </svg>
    </span>
    <span class="folder-records__item__content">
      <span class="folder-records__item__content__title"
        >Medical Record Summary</span
      >
      <span class="folder-records__item__content__ext">[PDF]</span>
    </span>
  </button>
</div>
